/* angular:styles/component:css;0151004c61f8a48b2353a289ed902e14208235ec32d6599edf9af5d39f35153a;/src/src/app/edge/live/Controller/Evse/pages/history/history.ts */
form {
  align-content: center !important;
}
/*# sourceMappingURL=history.css.map */
